import { Component, OnInit ,  OnDestroy} from '@angular/core';
import { NgForm, FormGroup, Validators, FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from '../auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Global } from '../../utilerias/global';
import swal from 'sweetalert2';
import { GenericoService } from 'src/app/shared/services/generico.service';
import { UrlConstantes } from 'src/app/utilerias/constantes/urlconstantes';
import { ModalEmailComponent } from '../login/modalEmail.component';
import { CommonModule } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import {MatFormFieldModule} from '@angular/material/form-field';
import { firstValueFrom } from 'rxjs';
declare var $: any;

@Component({
    selector: 'app-restauraPass',
    standalone: true,
    templateUrl: './restauraPass.component.html',
    imports: [
      FormsModule,
      ReactiveFormsModule,
      CommonModule,
      MatFormFieldModule
    ],
})
export class RestauraPassComponent implements OnInit, OnDestroy {
  token: string;
  formRegistro: FormGroup;
  dateTime = new Date();

  constructor(private authService: AuthService,private router: Router,private globals:Global, private formBuilder: FormBuilder,
     private genService: GenericoService, private route: ActivatedRoute, private dialog: MatDialog) { }

  ngOnInit() {
    const body = document.getElementsByTagName('body')[0];
    body.classList.add('login-page');
    body.classList.add('off-canvas-sidebar');
    this.globals.timeLeft=0;
    const card = document.getElementsByClassName('card')[0];
    const card2 = document.getElementsByClassName('card2')[0];
    setTimeout(function() {
        card.classList.remove('card-hidden');
        card2.classList.remove('card-hidden');
    }, 700);

    this.token = this.route.snapshot.queryParamMap.get('token');
    this.variablesTemplate();
  }

  variablesTemplate(){
    this.formRegistro = this.formBuilder.group({
      password: ['', Validators.required],     
      confirmPassword:  ['', Validators.required]          
    },{
      validator: this.validaPassword('password', 'confirmPassword')
    });
  }

  validaPassword(pass, confirmPassword) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[pass];
      const matchingControl = formGroup.controls[confirmPassword];

      if (matchingControl.errors && !matchingControl.errors.mustMatch) {
        return;
      }
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ mustMatch: true });
      } else {
        matchingControl.setErrors(null);
      }
    }
  } 

  ngOnDestroy(){
    const body = document.getElementsByTagName('body')[0];
    body.classList.remove('login-page');
    body.classList.remove('off-canvas-sidebar');  
    
  }


  onSignin(form: NgForm) {
    const password = form.value.password;
    firstValueFrom(
      this.genService.ejecutaServicioSinObtenerElemento2(
        UrlConstantes.actualizaPassword,
        password,
        this.token
      )
    ).then(res=>{
      console.log(res);
      this.muestraMensaje(res);
    });    
  }

   DeleteUnsavedImages(){
    this.router.navigate(['/security/login']);
  } 

  muestraMensaje(respuesta: any){
    switch(respuesta.pCodRetorno){
      case "00000": /*Exitoso*/
      swal.fire({
        title: "¡Exitoso!",
        text: respuesta.pMensaje,
        timer: 5000,
        showConfirmButton: false,
        icon: "success",
        // close:   () => {
        //   this.router.navigate(['/security/login']);
        // }
      
    })
  
        break;
      case "00001": /*Expirado*/
      swal.fire({
        title: 'Atención',
        text: respuesta.pMensaje,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Intentar nuevamente',
        cancelButtonText: 'Intentar más tarde',
        customClass:{
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger',
        },
        buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        let dialogRef = this.dialog.open(ModalEmailComponent, {
          width: '460px',
          panelClass: 'custom-modalbox'
        });
      } else {
        this.router.navigate(['/security/login']);
      }
    });
        break;      

      case "00002": /*Error de peticion*/
      swal.fire({
        title: "¡Error!",
        text: respuesta.pMensaje,
        timer: 5000,
        showConfirmButton: false,
        icon: 'error'
    })
        break;
    }
    
  }

  
  

}
